import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { OperationData } from '@atlassian/jira-shareable-entity-dialog/src/model/types.tsx';
import { transformCopyFilter } from '../transformers/index.tsx';

const createFilter = (
	filter: OperationData,
	jql: string,
	isFavourite: boolean,
	overrideSharePermissions: boolean,
) => {
	const body = transformCopyFilter(filter, jql, isFavourite);

	return performPostRequest(
		`/rest/api/2/filter${overrideSharePermissions ? '?overrideSharePermissions=true' : ''}`,
		{
			body: JSON.stringify(body),
		},
	);
};

export default createFilter;
